import moment from "moment";

export default {
  methods: {
    isValidPesel(pesel) {
      if (typeof pesel != "string") return false;

      const controlNumber = parseInt(pesel.substring(10, 11));
      const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
      let sum = 0;

      for (let i = 0; i < weight.length; i++) {
        sum += parseInt(pesel.substring(i, i + 1)) * weight[i];
      }
      sum = sum % 10;

      return (10 - sum) % 10 == controlNumber;
    },
    hasAgeBettwen(date, minAge, maxAge) {
      const age = getAgeFromDate(date);

      return age >= minAge && age <= maxAge;
    },
    hasAgeGreaterThan(date, minAge) {
      const age = getAgeFromDate(date);

      return age > minAge;
    },
    hasPeselAgeBettwen(pesel, minAge, maxAge) {
      if (pesel.length != 11) return false;

      const age = getAgeFromPesel(pesel);

      return age > minAge && age < maxAge;
    },
    hasPeselAgeGreaterThan(pesel, minAge) {
      if (pesel.length != 11) return false;

      const age = getAgeFromPesel(pesel);

      return age > minAge;
    },
  },
};

const getAgeFromDate = (date) => {
  const today = new Date();
  const birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const getAgeFromPesel = (pesel) => {
  const today = new Date();
  const dateFromPesel = getBirthDateFromPesel(pesel);
  const birthDate = new Date(dateFromPesel.replace(/-/g, "/"));
  let age = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();

  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const getBirthDateFromPesel = (pesel) => {
  let peselInt = pesel.split("").map(Number);
  let year = 1900 + peselInt[0] * 10 + peselInt[1];

  if (peselInt[2] >= 2 && peselInt[2] < 8) {
    year += Math.floor(peselInt[2] / 2) * 100;
  }

  if (peselInt[2] >= 8) {
    year -= 100;
  }

  const month = (peselInt[2] % 2) * 10 + peselInt[3];
  const day = peselInt[4] * 10 + peselInt[5];

  return moment().set({ year, month, day }).format("YYYY-MM-DD");
};
